import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSmartphone, FiMail, FiShare2, FiLock } = FiIcons;

const GuestWiFi = () => {
  return (
    <section id="guest-wifi" className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-16">
          
          {/* Mockup Side */}
          <div className="w-full lg:w-1/2 flex justify-center">
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="relative w-[300px] h-[600px] bg-slate-900 rounded-[2.5rem] border-[8px] border-slate-800 shadow-2xl overflow-hidden flex flex-col"
            >
              {/* Phone Notch */}
              <div className="absolute top-0 w-full flex justify-center z-20">
                <div className="w-1/2 h-6 bg-slate-800 rounded-b-2xl"></div>
              </div>
              
              {/* Splash Page Content Mockup */}
              <div className="flex-1 bg-white flex flex-col items-center justify-center p-8 relative z-10">
                <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                  <SafeIcon icon={FiIcons.FiWifi} className="text-4xl text-blue-600" />
                </div>
                <h4 className="text-2xl font-bold text-slate-900 mb-2 text-center">Free Guest WiFi</h4>
                <p className="text-center text-sm text-slate-500 mb-8">Welcome to our location. Please log in to connect.</p>
                
                <button className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold mb-3 flex items-center justify-center gap-2">
                  <SafeIcon icon={FiMail} /> Connect with Email
                </button>
                <button className="w-full bg-slate-100 text-slate-700 py-3 rounded-lg font-semibold flex items-center justify-center gap-2">
                  <SafeIcon icon={FiShare2} /> Social Login
                </button>
                
                <p className="text-[10px] text-slate-400 text-center mt-6">By connecting, you agree to our Terms of Service.</p>
              </div>
            </motion.div>
          </div>

          {/* Text Side */}
          <div className="w-full lg:w-1/2">
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-blue-600 font-semibold tracking-wide uppercase text-sm mb-3">Captive Portals</h2>
              <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">Branded Guest WiFi That Works for You</h3>
              <p className="text-lg text-slate-600 mb-8">
                Turn your free customer WiFi into a powerful marketing tool while maintaining strict security for your internal business operations.
              </p>

              <div className="space-y-6">
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center">
                    <SafeIcon icon={FiSmartphone} className="text-blue-600 text-xl" />
                  </div>
                  <div>
                    <h5 className="text-lg font-bold text-slate-900 mb-1">Custom Splash Pages</h5>
                    <p className="text-slate-600">Greet guests with a beautiful, branded login portal featuring your logo and promotional messaging.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center">
                    <SafeIcon icon={FiMail} className="text-blue-600 text-xl" />
                  </div>
                  <div>
                    <h5 className="text-lg font-bold text-slate-900 mb-1">Customer Data Collection</h5>
                    <p className="text-slate-600">Require an email address or social media login to access the internet, building your marketing list effortlessly.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center">
                    <SafeIcon icon={FiLock} className="text-blue-600 text-xl" />
                  </div>
                  <div>
                    <h5 className="text-lg font-bold text-slate-900 mb-1">Secure Network Separation</h5>
                    <p className="text-slate-600">Guest traffic is completely isolated from your point-of-sale systems, servers, and employee networks using strict VLANs.</p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default GuestWiFi;